import React, { Component, useEffect, useState, useRef } from "react";
import DialCode from './PaymentDetails/DialCode';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { ConfirmationAgentForgot, registrationagentemailcheck } from './axios';
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./AgentSignup.css";
import Spinner from 'react-bootstrap/Spinner';

//const regularExpression = RegExp(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/)
const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);


export default function AgentForgotPass() {
    const [sussessRegister, setSussessRegister] = useState(false);
    const [EmailRecheck, setEmailRecheck] = useState(false);
    const [EmailRecheckMessage, setEmailRecheckMessage] = useState("");
    const [btnloader, setbtnloader] = useState(0);
    const {
        register,
        handleSubmit, watch,
        formState: { errors },
      } = useForm({
        mode: "onChange",
      });
    // static propTypes = {
    //     cookies: instanceOf(Cookies).isRequired
    // };
   
    useEffect(() => {
        
    }, []);
   
      // Start On Change Status Data Show
      const onChange = (e) => {
     };

     const password = useRef({});
        password.current = watch("password", "");
     // End On Change Status Data Show
     // On Submit User List
      const onSubmit = (data) => {
        let subData = true;
        setbtnloader(1);
         //Check Validation Email
         //let emailDetails = 'vijay.kapoor@teraidatalabs.com';
       
         registrationagentemailcheck(data.email).then(
      ({data, message}) => {
        setbtnloader(0);
        //console.log(data);
        if (data == "exist") {
          setEmailRecheck(false);
          setEmailRecheckMessage("");
         // return (subData = false);
        } else {
          setEmailRecheck(true);
          setEmailRecheckMessage(message);
           return (subData = false);
        }
      },
      (error) => {}
    );
    setTimeout(() => {
        if (subData) {
          setSussessRegister(false);
            let email = data.email;
            ConfirmationAgentForgot(email).then(
            (data) => {
              //  console.log(data);
                setSussessRegister(true);
               
                var base_url = window.location.origin;
                window.location.href = base_url+"/agentforgotcompleted";
                setbtnloader(0);
            },
            (error) => {
    
            }
        );
           
        }

      }, 3000);
      }
    



    return (
      <div id="login">
      <aside id="agentlogin" style={{ width: '25%'}}>
          <figure> <a href="/"><img src="images/logo/seyLogo.png" alt="Holiday Seychelles" class="logo_sticky" /></a> </figure>
          {/* <p style={{fontSize: '20px', fontWeight: 600}}>Forgot Password</p> */}
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          {/* {sussessRegister && (
                    <div class="alert alert-success" role="alert">
                    We have sent an email on your registererd mail address that will help to reset password for your account.
                    </div>
                     )} */}
                     
            <div class="form-group">
              <label>Enter Your Email</label>
              <input   type="email"
                className={`form-control ${
                  errors.email && "Err"
                }`}
                {...register("email", {
                  required: true,
                  minLength: 2,
                  pattern:
                    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
                })}
                id="email"
                name="email"
                placeholder="Enter Email"
              />
              <i className="icon_mail_alt"></i>
              {errors.email &&
                errors.email.type === "required" && (
                  <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                    Please enter your Email
                  </span>
                )}
              {errors.email &&
                errors.email.type === "minLength" && (
                  <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                    Email must be at least 2 characters long!
                  </span>
                )}
              {errors.email &&
                errors.email.type === "pattern" && (
                  <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                    Please enter a valid email
                  </span>
                )}

              {EmailRecheck && (
                <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                 	<strong>Sorry !</strong> {EmailRecheckMessage}
                </span>
              )}
          </div>
            
            <div class="clearfix add_bottom_30">
              <div class="checkboxes float-left">
              </div>
             
            </div>
            <button type="submit" className="btn_1 rounded full-width">Submit  &nbsp;{btnloader === 1 ? (<Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          visually-hidden="true"
        />) : ""}</button>
            
            <div class="text-center add_top_10"><strong><Link to='/agentlogin'>Login</Link></strong></div>
          </form>
        </aside>
        </div> 
        );
   
}